import { MainColor } from '../../../palette/colors';

export const getCheckboxItem = () => {
  return {
    defaultState: {
      svgColor: 'coolGrey60' as MainColor,
      color: 'navy95' as MainColor,
    },
    hover: {
      backgroundColor: 'navy10' as MainColor,
    },
    checked: {
      svgColor: 'navy60' as MainColor,
      backgroundColor: 'navy10' as MainColor,
    },
  };
};

export type CheckboxItemTheme = ReturnType<typeof getCheckboxItem>;
